const initState=[];
const EncounterMenuRecordReducer = (state = initState, action) => {
    switch(action.type) {
        case  'EncounterMenuRecordAction' : return  action.payload ;
        default: return state;
    }
}
export default EncounterMenuRecordReducer;